import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {CommunicationContentSubstitutionModel} from '../../../api/model/communicationContentSubstitution.model';

@Injectable({
    providedIn: 'root'
})
export class CommunicationContentSubstitutionRepository extends AbstractRepositoryV2<CommunicationContentSubstitutionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('CommunicationContentSubstitution', serviceElementsFactory, injector);
    }
}
